// components/FloatPrecisionDropdownBase.tsx
import IconChevronDown from '@/assets/icons/font_awesome/chevron-down-solid.svg?react';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { UI_PRIMITIVE__dropdown_menu } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu';
import { UI_PRIMITIVE__dropdown_menu_content } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_content';
import { UI_PRIMITIVE__dropdown_menu_item } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_item';
import { UI_PRIMITIVE__dropdown_menu_trigger } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_trigger';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';
import { ETabsReservations } from './page_reservations_views_desktop';

interface Props {
  current_tab: ETabsReservations;
  set_current_tab: (value: ETabsReservations) => void;
}
export function ReservationTabsDropdown({ current_tab, set_current_tab }: Props) {
  const dispatch = use_dispatch();

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_DIFFUSION_MODELS);

  const trigger_id = 'dropdown_reservation';

  /*
   * EVENTS
   */

  async function on_item_selected_internal(value: string) {
    set_current_tab(value as ETabsReservations);

    // dispatch(local_ui_set_string({ key: 'page_diffusion_models_current_tab', value, valid_values: Object.values(EDiffusionModelsTab) }));
  }

  /*
   * METHODS
   */

  /*
   * RENDERS
   */

  function render_items() {
    return Object.entries(ETabsReservations).map(([key, value]) => {
      return (
        <UI_PRIMITIVE__dropdown_menu_item
          key={key}
          on_item_selected={on_item_selected_internal}
          values_selected={[current_tab]}
          {...{ value }}
          label={value}
          class_name_hovered_selected="bg-component-item"
          className={`settings-dropdown-item text-page-foreground `}
        />
      );
    });
  }

  /*
   * HTML
   */
  return (
    <div className="w-full px-2">
      <UI_PRIMITIVE__dropdown_menu>
        <UI_PRIMITIVE__dropdown_menu_trigger asChild>
          <UI_PRIMITIVE__button id={trigger_id} className="settings-dropdown-button bg-bar w-full text-page-foreground" variant="outline-on-component">
            tab: {current_tab}
            <IconChevronDown className="!w-3 !h-3" />
          </UI_PRIMITIVE__button>
        </UI_PRIMITIVE__dropdown_menu_trigger>
        <UI_PRIMITIVE__dropdown_menu_content trigger_id={trigger_id} className="rounded-lg">
          {render_items()}
        </UI_PRIMITIVE__dropdown_menu_content>
      </UI_PRIMITIVE__dropdown_menu>
    </div>
  );
}
